// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ltts-global-boundary .ant-result>.ant-result-content{background-color:rgba(0,0,0,0)}.ltts-global-boundary .ltts-global-boundary-error-field{color:red}", ""]);
// Exports
module.exports = exports;
